import React, { useState, useEffect } from "react";

const ShowMoreBtn = (props) => {
  const [showMore, setShowMore] = useState(false);
  useEffect(()=>{
      props.callback(showMore);
  },[showMore,props])
  return (
    <div className="button-row button-row--center">
      <div className="button-row__list">
        <button
          type="button"
          className="button-link"
          onClick={() => {
            setShowMore(!showMore);
          }}
        >
          {showMore ? props.showless : props.showmore}
        </button>
      </div>
    </div>
  );
};
export default ShowMoreBtn;
